// Privacy-friendly analytics - no user tracking, just aggregate counters
// Sends anonymous events to Cloudflare Worker that increments counters

const API_BASE = import.meta.env.DEV 
  ? 'http://localhost:8788' 
  : ''

// Track an event (fire and forget - don't block UI)
export function trackEvent(eventName, metadata = {}) {
  // Don't track in development by default
  if (import.meta.env.DEV && !import.meta.env.VITE_TRACK_DEV) {
    console.log('[Analytics Dev]', eventName, metadata)
    return
  }

  fetch(`${API_BASE}/api/analytics`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      event: eventName,
      ...metadata,
      // Include timestamp for daily bucketing on server
      timestamp: Date.now()
    })
  }).catch(() => {
    // Silently fail - analytics should never break the app
  })
}

// Convenience methods for common events
export const Analytics = {
  // App usage
  appLaunch: () => trackEvent('app_launch'),
  
  // Language
  languageSet: (lang) => trackEvent('language_set', { language: lang }),
  
  // Onboarding
  onboardingComplete: (settings) => trackEvent('onboarding_complete', {
    ageGroup: settings.ageGroup,
    learnerMode: settings.learnerMode,
    language: settings.culture?.split('-')[0] || 'en'
  }),
  
  // Stories
  storyStarted: (storyId) => trackEvent('story_started', { storyId }),
  storyCompleted: (storyId) => trackEvent('story_completed', { storyId }),
  
  // AI Creator
  aiStoryCreated: () => trackEvent('ai_story_created'),
  aiStoryRefined: () => trackEvent('ai_story_refined'),
}

export default Analytics
